import apiFetch from '../apiFetch'

export default function (token, financingTypeId, companyId) {
  return apiFetch({ endPoint: `FinancingType/${financingTypeId}/${companyId}`, method: 'DELETE', body: null, token: token })
}
